import { lazy, Suspense } from "react";
import { usePath } from "./lib/router.ts";
import { login, useSession } from "./lib/session.ts";
import { Mailbox } from "./routes/Mailbox.tsx";

const Design = import.meta.env.DEV || import.meta.env.VITE_DESIGN_ROUTE ? lazy(() => import("./routes/Design.tsx")) : null;

export function App() {
  const path = usePath();
  if (path.startsWith("/design") && Design) {
    return (
      <Suspense fallback={null}>
        <Design />
      </Suspense>
    );
  }
  return <Home />;
}

function Home() {
  const s = useSession();
  if (s.status === "loading") return null;
  if (s.status === "error")
    return (
      <Centered>
        <p className="rule-left danger" role="alert">{s.message}</p>
      </Centered>
    );
  if (s.status === "anon")
    return (
      <Centered>
        <span className="eyebrow">Homing</span>
        <h1 style={{ fontSize: 40, margin: "18px 0 28px" }}>Mail, set like a book.</h1>
        <button className="btn primary" onClick={() => login()} data-testid="login">
          Sign in with Flock ID
        </button>
      </Centered>
    );
  return <Mailbox me={s.me} offline={s.offline} />;
}

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <main className="chrome" style={{ maxWidth: 760, margin: "0 auto", padding: "15vh var(--gutter) 0" }}>
      {children}
    </main>
  );
}
